import { getQueryParams, httpApi } from '@FW/api/http.api';

/**
 * Get list of disabled wallets (ones not to show in the widget).
 */
export const getHiddenWallets = () =>
	httpApi
		.get(`InterfacePreferences/WalletsOverview`, { params: getQueryParams() })
		.then(({ data }) => data)
		.catch((err) => {
			throw err;
		});

/**
 * Update the list of disabled wallets (ones not to show in the widget).
 *
 * @param wallets - Array of WalletGUIDs.
 */
export const setHiddenWallets = (wallets: string[]) =>
	httpApi
		.post(`InterfacePreferences/WalletsOverview`, wallets, { params: getQueryParams() })
		.then((loadData) => loadData)
		.catch((err) => {
			throw err;
		});
